<template>
  <sj-question-item :prop="questionIndex"
                    ref="sjQuestionItem">
    <template slot-scope="prop">
      <div @click="onQuestionFocus(questionIndex)">
        <layout-panel :class="['question-panel', focusClass]"
                      :collapse.sync="collapse"
                      style="margin-bottom: 10px;">

          <!-- 标题 -->
          <template slot="header">
            <span :title="question.id">Q{{ questionIndex + 1 }} {{ types[question.type] }}</span>
            <span v-show="prop.hasJump"
                  class="sj-icon-logic"></span>
            <span v-show="collapse"
                  class="text-ellipsis"
                  style="width: 300px;font-weight: normal;"
                  v-html="question.title"></span>
          </template>

          <!-- 工具栏 -->
          <template slot="tools">
            <div class="question-toolbar">
              <template v-if="isAppend || !disabled">
                <span v-if="!isAppend"
                      style="display: inline-block;">
                <sj-question-tooltip content="拖拽排序">
                  <button class="sj-icon-move-dot drag-question-button"/>
                </sj-question-tooltip>
              </span>
                <template v-for="{tip, icon, action} in buttons">
                  <sj-question-tooltip :content="tip"
                                       v-show="!collapse">
                    <sj-question-button
                      style="display: inline-block;"
                      v-model="questions"
                      :action="action">
                      <button :class="icon"/>
                    </sj-question-button>
                  </sj-question-tooltip>
                </template>
              </template>
              <span style="display: inline-block;">
                <sj-question-tooltip content="发送到模板">
                  <button class="sj-icon-share"
                          @click.stop="sendQuestionTo"/>
                </sj-question-tooltip>
              </span>
            </div>
          </template>

          <!-- 问题内容 -->
          <el-form
            ref="questionForm"
            :rules="questionRules"
            :model="question"
            @submit.native.prevent>
            <el-form-item prop="title">
              <sj-question-inline-rich-text
                v-model="question.title"
                prefix-icon="sj-icon-title"
                :disabled="disabled"
                @input="validateTitle"
                placeholder="请输入题目标题"></sj-question-inline-rich-text>
            </el-form-item>

            <!-- 后端描述 -->
            <el-row>
              <el-col>
                <el-form-item prop="text">
                  <sj-question-inline-rich-text
                    v-model="question.auditText"
                    prefix-icon="sj-icon-moban"
                    :disabled="disabled"
                    :toolbar="[
                        ['bold', 'italic', 'underline', 'strike'],
                        [{'color': ['', '#F00']}],
                        ['clean'],
                      ]"
                    placeholder="请输入后端描述"></sj-question-inline-rich-text>
                </el-form-item>
              </el-col>
            </el-row>

            <!-- 描述 -->
            <el-row :gutter="15">
              <el-col :lg="12">
                <el-form-item prop="text">
                  <sj-question-rich-text
                    v-model="question.text"
                    :disabled="disabled"
                    placeholder="请输入描述内容，请勿直接从Word、WPS等文字编辑软件直接复制粘贴带有格式的文字，模板内的复制粘贴是允许的。"
                    @click="onQuestionFocus(questionIndex)"></sj-question-rich-text>
                </el-form-item>
              </el-col>
              <el-col :lg="12">
                <el-form-item prop="images">
                  <sj-question-image v-model="question.images"
                                     :disabled="disabled"></sj-question-image>
                </el-form-item>
              </el-col>
            </el-row>

            <!-- 选项 -->
            <template v-if="question.options">
              <sj-question-option :model="question.options">
                <draggable
                  :list="question.options"
                  :options="{disabled: disabled, handle: '.drag-option-button'}">
                  <transition-group>
                    <sj-question-option-item v-for="(option, optionIndex) of question.options"
                                             :key="option.id"
                                             :prop="optionIndex"
                                             class="question-option">
                      <template slot-scope="prop">
                        <div @click.stop="onQuestionFocus(questionIndex, optionIndex)">
                          <el-form
                            ref="optionForm"
                            :rules="questionOptionRules"
                            :model="option"
                            @submit.native.prevent>

                            <el-form-item prop="title">
                              <el-container :gutter="15">
                                <div class="width-max">
                                  <el-input
                                    v-model="option.title"
                                    :prefix-icon="getOptionIcon(question.type)"
                                    :suffix-icon="prop.hasJump?'sj-icon-logic':''"
                                    :disabled="disabled"
                                    placeholder="请输入选项标题">
                                    <template slot="prepend">
                                      <span>OPT{{ optionIndex + 1 }}</span>
                                    </template>
                                  </el-input>
                                </div>

                                <!-- 选项按钮 -->
                                <div v-if="!disabled"
                                     class="question-option-toolbar">
                                  <sj-question-tooltip content="拖拽排序">
                                    <el-button icon="sj-icon-move-dot"
                                               class="drag-option-button"></el-button>
                                  </sj-question-tooltip>
                                  <template v-for="{tip, icon, action} in buttons">
                                    <sj-question-tooltip :content="tip">
                                      <sj-question-option-button
                                        v-model="question.options"
                                        :action="action">
                                        <el-button :icon="icon"></el-button>
                                      </sj-question-option-button>
                                    </sj-question-tooltip>
                                  </template>
                                </div>
                              </el-container>
                            </el-form-item>

                            <!-- 单选题得示例信息 -->
                            <template v-if="question.type === 'select'">
                              <el-row :gutter="15">
                                <el-col :lg="12">
                                  <el-form-item prop="text">
                                    <sj-question-wang-rich-text
                                      v-model="option.exampleText"
                                      :disabled="disabled"
                                      placeholder="请输入示例内容，请勿直接从Word、WPS等文字编辑软件直接复制粘贴带有格式的文字，模板内的复制粘贴是允许的。"></sj-question-wang-rich-text>
                                  </el-form-item>
                                </el-col>
                                <el-col :lg="12">
                                  <el-form-item prop="exampleImages">
                                    <sj-question-image v-model="option.exampleImages"
                                                       :disabled="disabled"></sj-question-image>
                                  </el-form-item>
                                </el-col>
                              </el-row>
                            </template>
                            <!-- 图片多选题 -->
                            <template v-if="question.type === 'imageMultiselect'">
                              <el-form-item prop="images">
                                <sj-question-one-image v-model="option.images"
                                                       :disabled="disabled"></sj-question-one-image>
                              </el-form-item>
                            </template>
                          </el-form>
                        </div>
                      </template>
                    </sj-question-option-item>
                  </transition-group>
                </draggable>
                <el-form-item prop="options">
                  <!-- 添加选项 -->
                  <sj-question-option-button
                    v-if="!disabled"
                    v-model="question.options"
                    action="add"
                    :options="{type: question.type}"
                    style="width: 100%;">
                    <el-button
                      plain
                      style="width: 100%;">添加选项
                    </el-button>
                  </sj-question-option-button>
                </el-form-item>
              </sj-question-option>
            </template>

          </el-form>

        </layout-panel>
      </div>

      <layout-panel v-if="visibleGuide"
                    :class="['question-panel', focusClass]"
                    :collapse.sync="collapseGuide"
                    style="margin-bottom: 10px;">
        <!-- 标题 -->
        <template slot="header">
          <span :title="question.id">Q{{ questionIndex + 1 }}</span>
          <span>任务指引</span>
        </template>
        <el-form label-position="top"
                 label-width="70px"
                 @submit.native.prevent>
          <el-form-item prop="guideText">
            <el-input
              v-model="question.guideText"
              placeholder="请输入任务指引说明"
              :disabled="disabledGuide">
            </el-input>
          </el-form-item>
          <el-row :gutter="15">
            <el-col :lg="12">
              <el-form-item prop="guideVideo">
                <sj-question-guide-video v-model="question.guideVideo"
                                         :disabled="disabledGuide"></sj-question-guide-video>
              </el-form-item>
            </el-col>
            <el-col :lg="12">
              <el-form-item prop="guideAudio">
                <sj-question-guide-audio v-model="question.guideAudio"
                                         :disabled="disabledGuide"></sj-question-guide-audio>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </layout-panel>

      <div style="margin-bottom: 20px;"></div>
    </template>
  </sj-question-item>
</template>

<script>
import draggable from 'vuedraggable'
import { questionRules, questionOptionRules } from '../step-template.rules.js'
import SjQuestionItem from '@/views/question-editor/packages/sj-question/src/SjQuestionItem'
import SjQuestionButton from '@/views/question-editor/packages/sj-question/src/SjQuestionButton'
import SjQuestionTooltip from '@/views/question-editor/packages/sj-question-tooltip'
import SjQuestionInput from '@/views/question-editor/packages/sj-question-input/src/SjQuestionInput'
import SjQuestionRichText from '@/views/question-editor/packages/sj-question-rich-text'
import SjQuestionWangRichText from '@/views/question-editor/packages/sj-question-rich-text/src/SjQuestionWangRichText'
import SjQuestionInlineRichText from '@/views/question-editor/packages/sj-question-inline-rich-text'
import SjQuestionOption from '@/views/question-editor/packages/sj-question-option/src/SjQuestionOption'
import SjQuestionOptionButton from '@/views/question-editor/packages/sj-question-option/src/SjQuestionOptionButton'
import SjQuestionOptionItem from '@/views/question-editor/packages/sj-question-option/src/SjQuestionOptionItem'

import SjQuestionGuideVideo from '@/views/question-editor/components/SjQuestionGuideVideo'
import SjQuestionGuideAudio from '@/views/question-editor/components/SjQuestionGuideAudio'
import SjQuestionImage from '@/views/question-editor/components/SjQuestionImage'
import SjQuestionOneImage from '@/views/question-editor/components/SjQuestionOneImage'

export default {
  components: {
    SjQuestionOneImage,
    SjQuestionImage,
    SjQuestionGuideAudio,
    SjQuestionGuideVideo,
    SjQuestionOptionItem,
    SjQuestionOptionButton,
    SjQuestionOption,
    SjQuestionRichText,
    SjQuestionWangRichText,
    SjQuestionInlineRichText,
    SjQuestionInput,
    SjQuestionTooltip,
    SjQuestionButton,
    SjQuestionItem,
    draggable,
  },
  inject: ['page', 'visibleGuide'],
  props: {
    // disabled: Boolean,
    questionIndex: Number,
  },
  data () {
    let question = this.page.questions[this.questionIndex]
    let isDefault = this.page.defaultQuestionIds.includes(question.id)
    let isAppend = this.page.appendQuestionIds.includes(question.id)
    let buttons = [
      {
        tip: '上移',
        icon: 'sj-icon-shift-up',
        action: 'up',
      },
      {
        tip: '下移',
        icon: 'sj-icon-shift-down',
        action: 'down',
      },
      {
        tip: '复制',
        icon: 'sj-icon-copy',
        action: 'copy',
      },
      {
        tip: '移除',
        icon: 'el-icon-delete',
        action: 'remove',
      },
    ]

    if (isAppend) {
      buttons = [buttons[3]]
    }
    return {
      questionRules,
      questionOptionRules,
      buttons,
      focusClass: '',
      questions: this.page.questions,
      question: question,
      isAppend,
      collapse: this.page.collapse.base ? true : isDefault || isAppend,
      collapseGuide: this.page.collapse.guide ? true : isDefault || isAppend,
    }
  },
  computed: {
    ...Vuex.mapState('stepTemplate', {
      types: state => state.types,
      focusQuestionIndex: state => state.focusQuestionIndex,
      focusOptionIndex: state => state.focusOptionIndex,
    }),
    disabled () {
      return this.isAppend || this.page.disabled.base
    },
    disabledGuide () {
      return this.isAppend || this.page.disabled.guide
    },
  },
  created () {},
  mounted () {
    this.$nextTick(() => {
      this.page.sjQuestionItems[this.questionIndex] = this.$refs.sjQuestionItem
    })
  },
  updated () {
    this.question = this.questions[this.questionIndex]
    this.page.sjQuestionItems[this.questionIndex] = this.$refs.sjQuestionItem
    this.onQuestionFocus(this.questionIndex, null)
  },
  destroyed () {},
  methods: {
    validateTitle (value) {
      this.$refs.questionForm.validateField('title')
    },
    validate (callback) {
      let isValid = true
      // 验证全部的表单
      let forms = [this.$refs.questionForm, ...(this.$refs.optionForm || [])]
      forms.forEach((form) => {
        form.validate((valid) => {
          if (!valid) {
            isValid = false
          }
        })
      })
      callback(isValid, this.question)
    },
    getOptionIcon (type) {
      let icon = ''
      switch (type) {
        case 'multitext':
          icon = 'el-icon-edit-outline'
          break
        case 'select':
          icon = 'sj-icon-round-check'
          break
        case 'multiselect':
          icon = 'sj-icon-square-check'
          break
        case 'imageMultiselect':
          icon = 'sj-icon-square-check'
          break
        default:
          icon = ''
          break
      }
      return icon + ' color-info'
    },
    onQuestionFocus (questionIndex = null, optionIndex = null) {
      this.$store.commit('stepTemplate/setFocusIndex', {
        questionIndex,
        optionIndex,
      })
      // 性能原因 不使用 store computed，会导致 update 所有题目组件，实际只需要更新2个
      for (let children of this.$parent.$children) {
        if (children.questionIndex === questionIndex && !children.focusClass) {
          children.focusClass = 'focus'
        }
        if (children.questionIndex !== questionIndex && children.focusClass) {
          children.focusClass = ''
        }
      }
    },
    sendQuestionTo () {
      this.page.$refs.SendQuestionTo.open(this.question)
    },
  },
  filters: {},
}
</script>
<style lang="scss">
// 全局CSS
</style>
<style lang="scss"
       scoped>
// 带作用域的CSS
// https://vue-loader.vuejs.org/zh-cn/features/scoped-css.html
.question-panel {
  transition: 0.1s box-shadow ease-in;

  &.focus {
    box-shadow: 0 0 10px 5px rgba(0, 0, 0, 0.1);
  }

  .question-toolbar {
    display: inline-block;
    opacity: 0;
    transition: 0.1s opacity ease-in;
  }

  &:hover .question-toolbar {
    opacity: 1;
  }

  .question-option {
    .question-option-toolbar {
      display: none;

      button {
        padding: 12px;
        margin-left: 0;
      }
    }

    &:hover .question-option-toolbar {
      display: block;
      margin-left: 10px;
      min-width: 216px;
      width: 216px;
    }
  }
}
</style>
<style lang="scss"
       module>
// 带作用域的CSS
// 绑定class方式 <p :class="$style.red"></p>
// https://vue-loader.vuejs.org/zh-cn/features/css-modules.html
</style>



// WEBPACK FOOTER //
// src/views/step-template/components/StepTemplateQuestion.vue